import React, { Component } from "react";
// import Colors from "../Colors";
import {
  TextInput,
  Button,
  Checkbox,
  Snackbar,
  Surface,
} from "react-native-paper";
import Toaster from "./../../components/snackBar_toaster";

// import BackHandlerAndroid from './../AndroidBackHandler';
import {
  View,
  ScrollView,
  Image,
  StyleSheet,
  StatusBar,
  TouchableOpacity,
  KeyboardAvoidingView,
  ImageBackground,
  Platform,
  Keyboard,
  Text,
} from "react-native";

import {
  registation,
  dispatchClearRegistation,
  userNameVerify,
  clearUserNameVerify,
} from "./../../store/actions/index";
import { connect } from "react-redux";
import { Styles} from './../../components/UI-Components';
import ReCAPTCHA from "react-google-recaptcha";
// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import Toast, { DURATION } from 'react-native-easy-toast'
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// import Icons from 'react-native-vector-icons/FontAwesome';
const isIos = Platform.OS === "ios";
// import { deviceHeight, deviceWidth, firebaseLogEvent } from './../Utils';
// import OfflineHandler from './../OfflineHandler';
// import {Styles, Text} from "./../../components/UI-Components/index";
// import {BackButtonImage} from"./../UI-Components"

const logo = require("./../../assets/logo1.png");

class RegisterPage extends Component {
  state = {
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    captchaValue: null,
    userNameError: false,
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    phoneError: false,
    visible: false,
    snackbarMsg: "",
    showToast: false,
    toasterMessage: "",
    load: false,
    expired: false,
    callBack: 'not fired'
  };
  _reCaptchaRef = React.createRef();

  static navigationOptions = ({ navigation }) => {
    return {
      // headerTitle: 'QUESTIONS LIST',
      // headerBackground:
      //   (<LinearGradientComponent />),
      //   headerTintColor: Colors.headerTintColor,
      // headerTitleStyle: {
      //     color:Colors.headerTextColor,
      //     alignItems:'center',
      //     alignSelf: 'center',
      //     textAlign: 'center',
      //     fontWeight:Colors.headerTextFontWeight
      // },
      headerStyle: {
        backgroundColor: "#fff",
        elevation: 0,
        shadowOpacity: 0,
      },
      //   headerLeft: (<BackButtonImage
      //     onPress={() => {
      //       navigation.goBack()

      //     }}
      //     iconChange={false}/>)
    };
  };

  componentWillUnmount() {
    // this.props.dispatchClearRegistation();
    this.props.clearUserNameVerify();
  }

  componentDidMount() {
    // firebaseLogEvent('registration_screen', {});
    setTimeout(() => {
      this.setState({ load: true });
    }, 1500);
    // console.log("didMount - reCaptcha Ref-", this._reCaptchaRef);
  }
  
  handleCaptcha = value => {
    // console.log("Captcha value:", value);
    this.setState({
        captchaValue: value
       });
    // if value is null recaptcha expired
    if (value === null) this.setState({ expired: "true" });
  };
  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
    // console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };


  componentDidUpdate(prevProps) {
    if (prevProps.resStatus !== this.props.resStatus) {
      if (this.props.resStatus) {
        // this.props.navigation.navigate("RegistrationVerifyOtpScreen");
        const toastMsg =
          typeof this.props.resMessage === "string"
            ? this.props.resMessage
            : "Please verify using the OTP sent.";
        // firebaseLogEvent('registration_form_filled', {mobile: this.state.phone});
        this.showToaster(toastMsg);
        setTimeout(() => {
          this.props.history.push("/registrationVerifyOtpScreen");
        }, 1000);
      }
    }
    if (prevProps.errInfo !== this.props.errInfo) {
      const errMsg = [];
      if (this.props.errInfo && Object.keys(this.props.errInfo).length) {
        Object.keys(this.props.errInfo).map((key) => {
          errMsg.push(this.props.errInfo[key][0]);
        });

        this.showToaster(errMsg);
        this.setState({
          visible: true,
          snackbarMsg: errMsg.join(""),
        });
      }
    }

    if (prevProps.userNameVerifyerror !== this.props.userNameVerifyerror) {
      if (this.props.userNameVerifyerror) {
        const errorMsg =
          this.props.userNameVerifyErrorInfo ||
          "Please enter a valid user name";
        this.showToaster(errorMsg, 2000);
        this.errorHandler("userNameError", true);
      }
    }
  }

  checkUniqueUserName = (userName) => this.props.userNameVerify(userName);

  errorHandler = (fieldName, errVal) => {
    this.setState(
      {
        [fieldName]: errVal,
      },
      () => {
        if (fieldName === "userNameError" && !errVal) {
          this.checkUniqueUserName(this.state.userName);
        }
      }
    );
  };

  validateEmail = (email) => {
    if (/^[.a-zA-Z0-9]+@[.a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  validatePhone = (phone) => {
    if (/^([0|\+[0-9]{1,5})?([6-9][0-9]{9})$/.test(phone)) return true;
    return false;
  };

  showToaster = (msg) => {
    this.setState({
      showToast: true,
      toasterMessage: msg,
    });
  };

  // onSubmitWithReCAPTCHA = async () => {
  //   const token = await this.recaptchaRef.current.executeAsync();
  //   console.log(token, "ASasd")
 
  //   // apply to form data
  // }

  validate = () => {
    const { userName, firstName, lastName, email, phone, captchaValue } = this.state;

    let userNameError;
    let firstNameError;
    let lastNameError;
    let phoneError;
    let emailError;
    let captchaValueError;

    if (!(userName.length > 0)) {
      userNameError = true;
      this.errorHandler("userNameError", true);
    }

    if (!(firstName.length > 0)) {
      firstNameError = true;
      this.errorHandler("firstNameError", true);
    }

    if (!(lastName.length > 0)) {
      lastNameError = true;
      this.errorHandler("lastNameError", true);
    }
    if (!this.validateEmail(email)) {
      emailError = true;
      this.errorHandler("emailError", true);
    }
    if (!this.validatePhone(phone)) {
      phoneError = true;
      this.errorHandler("phoneError", true);
    }
    // if (captchaValue === null) {
    //   captchaValueError = true;
    //   this.errorHandler("captchaValueError", true);
    // }
    // !captchaValueError&&
    if (
      !userNameError &&
      !firstNameError &&
      !lastNameError &&
      !phoneError &&
      !emailError
    ) {
      // this.props.navigation.navigate("OtpScreen");
      
      this.props.registation(this.state);
    } else {
      // this.refs.toast.show('Please enter all fields');
      // this.onSubmitWithReCAPTCHA();
    }
  };

  render() {
    const {
      userName,
      firstName,
      lastName,
      email,
      phone,
      userNameError,
      firstNameError,
      lastNameError,
      phoneError,
      emailError,
    } = this.state;

    const signUpBtn =
      userName === "" ||
      firstName === "" ||
      lastName === "" ||
      email === "" ||
      phone === "";

   

    return (
      <div
        className='loginBox'
        style={{display: 'flex',
         justifyContent: 'center',
          alignItems: 'center' }}
      >
        <ScrollView>
         
          <div 
          style={{
            width: 350, 
            display: 'flex',
            height: 'auto',
            flexDirection: 'column',
            padding: 25, 
            paddingBottom: 10,
            marginTop: 5,
            marginBottom: 10,
            // justifyContent: 'center',
            borderRadius: 5, 
            alignSelf: 'center',
            boxShadow: '0px 1px 1px 1px rgba(0,0,0,0.6)',    
            // alignItems: 'center', 
              }}>
         
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                // marginBottom: 10,
              }}
            >
              <Image
                source={logo}
                style={{ width: 400, height: 50, marginBottom: 20 }}
                resizeMode="contain"
              />
            </View>

            <View style={{ alignItems: "center", marginBottom: 10 }}>
              <Text style={{ fontSize: 20, color: "#000" }}>Sign Up</Text>
            </View>

            <View style={styles.searchSection}>
              {(this.props.userNameVerifyerror || this.state.userNameError) && (
                <View style={{ textAlign: "right" }}>
                  <Text
                    style={{ color: "red", fontSize: 10, textAlign: "right" }}
                  >
                    {this.props.userNameVerifyErrorInfo
                      ? this.props.userNameVerifyErrorInfo
                      : "User name is invalid"}
                  </Text>
                </View>
              )}
              {this.props.userNameVerifyStatus && !this.state.userNameError && (
                <View>
                  <Text
                    style={{ color: "green", fontSize: 10, textAlign: "right" }}
                  >
                    Valid Username
                  </Text>
                </View>
              )}
              <View style={{flex: 1 ,}}>
                {/* <Icons style={styles.searchIcon}
                  name={ "id-card"}
                  size={18} /> */}
                <TextInput
                  mode="outlined"
                  style={[styles.inputBox]}
                  label="User Name"
                  size={12}
                  value={this.state.userName}
                  error={this.state.userNameError}
                  onChangeText={(value) =>
                    this.setState({ userName: value.trim() })
                  }
                  underlineColor={"#F5891F"}
                  // theme={{ colors: { placeholder: '#F5591F', text: 'rgba(0,0,0,0.7)', primary: '#F5591F', underlineColor: '#F5591F', } }}
                  theme={{
                    colors: {
                      placeholder: "#A4A4A4",
                      text: "rgba(0,0,0,0.7)",
                      primary: "#A4A4A4",
                      underlineColor: "#A4A4A4",
                    },
                  }}
                  onBlur={() =>
                    userName.length > 5
                      ? this.errorHandler("userNameError", false)
                      : this.errorHandler("userNameError", true)
                  }
                />
              </View>
            </View>
            <View
              style={{ fontSize: 10, flexDirection: "column", marginTop: 10 }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 4,
                }}
              >
                {/* <Icon  style={{color: '#AED581',marginRight:5}}                  
                              name={isIos ? "ios-arrow-dropright" : "md-arrow-dropright"}
                              size={12}
                            />                             */}
                <Text style={{ fontSize: 11, color: "#AED581" }}>
                  Min.6 characters, alphabets and digits. Eg:Alpha12
                </Text>
              </View>
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                {/* <Icon  style={{color:"#FF5722",marginRight:5}}                  
                                name={isIos ? "ios-arrow-dropright" : "md-arrow-dropright"}
                                size={12}                                
                            />                             */}
                <Text style={{ fontSize: 11, color: "#FF5722" }}>
                  Special characters are not allowed.
                </Text>
              </View>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                marginVertical: 10,
              }}
            >
              <View style={{ width: "48%" }}>
                {(firstNameError || lastNameError) && (
                  <Text
                    style={{
                      color: "red",
                      fontSize: 10,
                      marginVertical: 3,
                      textAlign: "right",
                    }}
                  >
                    {firstNameError && "Enter first Name"}
                  </Text>
                )}
                <View style={{ width: "100%" }}>
                  {/* <Icon style={styles.searchIcon1}
                  name={isIos ? "ios-contact" : "md-contact"}
                  size={20} /> */}
                  <TextInput
                    mode="outlined"
                    style={[styles.inputBox]}
                    label="First Name"
                    value={this.state.firstName}
                    error={this.state.firstNameError}
                    onChangeText={(value) =>
                      this.setState({ firstName: value.trim() })
                    }
                    underlineColor={"#F5591F"}
                    theme={{
                      colors: {
                        placeholder: "#A4A4A4",
                        text: "rgba(0,0,0,0.7)",
                        primary: "#A4A4A4",
                        underlineColor: "#A4A4A4",
                      },
                    }}
                    // theme={{ colors: { placeholder: '#F5591F', text: 'rgba(0,0,0,0.7)', primary: '#F5591F', underlineColor: '#F5591F', } }}
                    onBlur={() =>
                      firstName.length > 0
                        ? this.errorHandler("firstNameError", false)
                        : this.errorHandler("firstNameError", true)
                    }
                  />
                </View>
              </View>

              <View style={{ width: "48%" }}>
                {(lastNameError || firstNameError) && (
                  <Text
                    style={{
                      color: "red",
                      fontSize: 10,
                      marginVertical: 3,
                      textAlign: "right",
                    }}
                  >
                    {lastNameError && "Enter last name"}
                  </Text>
                )}
                <View style={{ width: "100%" }}>
                  {/* <Icon style={styles.searchIcon1}
                  name={isIos ? "ios-contact" : "md-contact"}
                  size={20} /> */}
                  <TextInput
                    mode="outlined"
                    style={[styles.inputBox]}
                    label="Last Name"
                    value={this.state.lastName}
                    error={this.state.lastNameError}
                    onChangeText={(value) =>
                      this.setState({ lastName: value.trim() })
                    }
                    underlineColor={"#F5591F"}
                    theme={{
                      colors: {
                        placeholder: "#A4A4A4",
                        text: "rgba(0,0,0,0.7)",
                        primary: "#A4A4A4",
                        underlineColor: "#A4A4A4",
                      },
                    }}
                    // theme={{ colors: { placeholder: '#F5591F', text: 'rgba(0,0,0,0.7)', primary: '#F5591F', underlineColor: '#F5591F', } }}
                    onBlur={() =>
                      lastName.length > 0
                        ? this.errorHandler("lastNameError", false)
                        : this.errorHandler("lastNameError", true)
                    }
                  />
                </View>
              </View>

              {/* <Text style={{ color: "red", marginVertical: 3 }}>
                {lastNameError && "Enter last name"}
              </Text> */}
            </View>
            <View style={styles.searchSection}>
              {emailError && (
                <Text
                  style={{
                    color: "red",
                    fontSize: 10,
                    marginVertical: 1,
                    textAlign: "right",
                  }}
                >
                  Enter email address
                </Text>
              )}
              <View style={{ width: "100%" }}>
                {/* <Icon style={styles.searchIcon1}
                  name={isIos ? "ios-mail" : "md-mail"}
                  size={20} /> */}
                <TextInput
                  mode="outlined"
                  style={[styles.inputBox]}
                  label="Email Address"
                  value={this.state.email}
                  error={this.state.emailError}
                  keyboardType="email-address"
                  onChangeText={(value) =>
                    this.setState({ email: value.trim() })
                  }
                  underlineColor={"#F5591F"}
                  theme={{
                    colors: {
                      placeholder: "#A4A4A4",
                      text: "rgba(0,0,0,0.7)",
                      primary: "#A4A4A4",
                      underlineColor: "#A4A4A4",
                    },
                  }}
                  // theme={{ colors: { placeholder: '#F5591F', text: 'rgba(0,0,0,0.7)', primary: '#F5591F', underlineColor: '#F5591F', } }}
                  onBlur={() =>
                    this.validateEmail(email)
                      ? this.errorHandler("emailError", false)
                      : this.errorHandler("emailError", true)
                  }
                />
              </View>
            </View>
            <View style={{ marginTop: 12 }}>
              {phoneError && (
                <Text
                  style={{
                    color: "red",
                    fontSize: 10,
                    marginVertical: 3,
                    textAlign: "right",
                  }}
                >
                  Enter mobile number
                </Text>
              )}
              <View style={{ width: "100%" }}>
                {/* <Icon style={styles.searchIcon1}
                  name={isIos ? "ios-phone-portrait" : "md-phone-portrait"}
                  size={20} /> */}
                <TextInput
                  mode="outlined"
                  style={[styles.inputBox]}
                  label="Mobile Number"
                  size={12}
                  keyboardType="number-pad"
                  value={this.state.phone}
                  error={this.state.phoneError}
                  maxLength={10}
                  onChangeText={(value) =>{
                    if(value.length > 10 ) return null
                    this.setState({ phone: value.trim() })
                  }
                  }
                  underlineColor={"#F5591F"}
                  theme={{
                    colors: {
                      placeholder: "#A4A4A4",
                      text: "rgba(0,0,0,0.7)",
                      primary: "#A4A4A4",
                      underlineColor: "#A4A4A4",
                    },
                  }}
                  // theme={{ colors: { placeholder: '#F5591F', text: 'rgba(0,0,0,0.7)', primary: '#F5591F', underlineColor: '#F5591F', } }}
                  onBlur={() =>
                    this.validatePhone(phone)
                      ? this.errorHandler("phoneError", false)
                      : this.errorHandler("phoneError", true)
                  }
                />
              </View>
              {/* {
                this.state.load && 
                <View style={{ width: "100%" , flex: 1, marginTop:  10, justifyContent: 'center', alignItems: 'center'}}>
                <ReCAPTCHA
                  sitekey="6Lc7KKcZAAAAABao4EMzRe-52T1184H65Ux4G7jz"
                  ref={this._reCaptchaRef}
                  // sitekey={TEST_SITE_KEY}
                  onChange={this.handleCaptcha}
                  asyncScriptOnLoad={this.asyncScriptOnLoad}
                />
              {
              this.state.captchaValueError && (
                <Text
                  style={{
                    color: "red",
                    fontSize: 10,
                    marginVertical: 3,
                    textAlign: "right",
                  }}
                >
                  Invalid capture
                </Text>
              )
              }
                </View>
              } */}
            </View>

            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginTop: 25,
              }}
            >
              <Button
                disabled={this.props.loading}
                uppercase={false}
                onPress={() => {
                  //   Keyboard.dismiss()
                  this.validate();
                }}
                loading={this.props.loading ? true : false}
                mode="contained"
                style={styles.button}
              >
                <Text style={{ fontSize: 14, fontWeight: "400" }}>
                  {" "}
                  Sign Up
                </Text>
              </Button>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 20,
                marginBottom: 10
              }}
            >
              <Text style={styles.bottomText}>Already have an account ?</Text>
              <Text
                style={styles.signupText}
                onPress={() => {
                  this.props.history.push("/");
                }}
              >
                Login
              </Text>
            </View>
          </div>
        </ScrollView>

 
        <Toaster
          show={this.state.showToast}
          message={this.state.toasterMessage}
        />
      </div>

    );
  }
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    // marginHorizontal:10,
    // alignItems: "center",
    // backgroundColor: "#425168"
  },
  inputBox: {
    position: "relative",
    // width: "100%",
    // backgroundColor: 'transparent',
    // marginTop: 0,
    // paddingTop: 0,
    // paddingVertical: 0,
    // marginVertical: 0,
    // fontSize: 12
  },
  button: {
    width: 150,
    backgroundColor: Styles.primaryColor,
    marginVertical: 5,
    // fontSize: 12,
    borderRadius: 25,
    // paddingVertical:2,
  },
  buttonText: {
    fontSize: 14,
    // fontWeight:'500',
    color: "#fff",
    textAlign: "center",
  },
  forgetText: {
    // marginVertical: 25
  },
  bottomText: {
    // marginTop: 30,
    // marginBottom: 70,

    ...Platform.select({
      android: {
        color: "#222",
      },
      ios: {
        // color: "#fff",
      },
    }),
  },
  signupText: {
    fontSize: 14,
    fontWeight: "500",
    // paddingLeft: 15,
    // marginTop: 20,
    marginLeft: 5,
    ...Platform.select({
      android: {
        color: "blue",
        fontWeight: "400",
      },
      ios: {
        color: "blue",
        fontWeight: "600",
      },
    }),
  },
  splashBackgroundImage: {
    // flex: 1,
    width: "100%",
    height: "100%",
    //  resizeMode: 'cover',
    //  alignItems:'center',
    //  justifyContent:'center'
  },
  searchSection: {
    // flexDirection: 'row',
    // justifyContent: 'center',
    // alignItems: 'center',
    // width:'85%',
    // borderWidth:1,
    marginTop: 5,
  },
  searchIcon: {
    position: "absolute",
    right: 15,
    top: 25,
    // paddingHorizontal: 20,
    color: "#A4A4A4",
    // marginLeft: 25,
    // paddingLeft: 40
  },
  searchIcon1: {
    position: "absolute",
    right: 15,
    top: 25,
    // paddingHorizontal: 20,
    color: "#A4A4A4",
    // marginLeft: 25,
    // paddingLeft: 40
  },
});

const mapStateToProps = (state) => ({
  loading: state.registration && state.registration.loading,
  err: state.registration && state.registration.err && state.registration.err,
  errInfo:
    state.registration &&
    state.registration.errInfo &&
    state.registration.errInfo.response &&
    state.registration.errInfo.response.data &&
    state.registration.errInfo.response.data.message &&
    state.registration.errInfo.response.data.message,
  status:
    state.registration &&
    state.registration.response &&
    state.registration.response,
  resStatus:
    state.registration &&
    state.registration.resStatus &&
    state.registration.resStatus,
  resMessage:
    state.registration &&
    state.registration.response &&
    state.registration.response.message,
  uerNameVerifyLoading: state.userNameVerify && state.userNameVerify.loading,
  userNameVerifyerror: state.userNameVerify && state.userNameVerify.error,
  userNameVerifyErrorInfo:
    state.userNameVerify &&
    state.userNameVerify.errorInfo &&
    state.userNameVerify.errorInfo.response &&
    state.userNameVerify.errorInfo.response.data &&
    state.userNameVerify.errorInfo.response.data.message,
  userNameVerifyStatus:
    state.userNameVerify &&
    state.userNameVerify.response &&
    state.userNameVerify.response.status,
});

export default connect(mapStateToProps, {
  registation,
  dispatchClearRegistation,
  userNameVerify,
  clearUserNameVerify,
})(RegisterPage);
